import React from 'react';
import { ShieldCheckIcon, DownloadIcon, SmartphoneIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function OfferSection() {
  return <section id="comprar" className="w-full py-24 px-4 bg-gradient-to-b from-white to-brand-lavender/40" data-id="element-144">
      <div className="max-w-4xl mx-auto text-center" data-id="element-145">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-slate mb-6" data-id="element-146">
          Recupera el control hoy
        </h2>

        <p className="text-xl text-brand-navy max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-147">
          Hoy puedes obtener el control total sobre tus episodios de ansiedad y
          la tranquilidad de saber exactamente qué hacer cuando el pánico
          aparezca.
        </p>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-brand-lavenderDark/30 max-w-2xl mx-auto relative overflow-hidden" data-id="element-148">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-coral" data-id="element-149"></div>

          <div className="mb-8" data-id="element-150">
            <span className="inline-block bg-red-100 text-red-700 text-sm font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wide" data-id="element-151">
              🔥 Oferta especial — 78% de descuento
            </span>
            <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-152">
              <span className="text-2xl md:text-3xl text-brand-navy/50 line-through font-medium" data-id="element-153">
                $29
              </span>
              <span className="text-6xl md:text-7xl font-bold text-brand-slate tracking-tight" data-id="element-154">
                $6.39
              </span>
              <span className="text-2xl text-brand-navy ml-1 font-medium" data-id="element-155">
                USD
              </span>
            </div>
            <p className="text-green-700 font-semibold text-sm mt-2" data-id="element-156">
              Acceso inmediato · Ahorras $22.61
            </p>
          </div>

          <a href="https://guiasparavivir.com/cart/52494055244065:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full bg-brand-coral hover:bg-brand-coralDark text-white font-bold text-xl py-5 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 mb-6" aria-label="Descargar mi Guía de Control de Ansiedad" data-id="element-157">
            Descargar mi Guía de Control de Ansiedad &rarr;
          </a>

          <p className="text-brand-navy font-medium mb-8" data-id="element-158">
            Recupera tu paz mental. Pago seguro y descarga instantánea.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-8 border-t border-brand-creamDark" data-id="element-159">
            <div className="flex items-center text-brand-slate text-sm font-medium" data-id="element-160">
              <ShieldCheckIcon className="w-5 h-5 text-green-600 mr-2" aria-hidden="true" data-id="element-161" />
              Pago seguro
            </div>
            <div className="flex items-center text-brand-slate text-sm font-medium" data-id="element-162">
              <DownloadIcon className="w-5 h-5 text-brand-purple mr-2" aria-hidden="true" data-id="element-163" />
              Descarga instantánea
            </div>
            <div className="flex items-center text-brand-slate text-sm font-medium" data-id="element-164">
              <SmartphoneIcon className="w-5 h-5 text-brand-navy mr-2" aria-hidden="true" data-id="element-165" />
              Lee en cualquier dispositivo
            </div>
          </div>
        </div>
      </div>
    </section>;
}